import React from "react";

export default function BankDetail(){
    return(
        <>BankDetail
        </>
    )
}